module.exports = __webpack_public_path__ + "static/media/cowinBackArrow.25f931e1.svg";